import { FloatingBox } from '../../display/FloatingBox/FloatingBox.es.js';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { TypographyPDL } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';
import { css, jsx } from '@emotion/react';

const MENU_ITEM_HEIGHT = 40;
const Styles = labelStyles("FloatingMenu", {
  list: ({ visibleItems }) => [
    {
      maxHeight: ((visibleItems || 0) + 0.5) * MENU_ITEM_HEIGHT + 10,
      // add extra height to suggest scrollability for overflow
      overflow: "auto",
      padding: 10
    }
  ],
  menuItem: ({ isDisabled, isHighlighted }) => [
    Object.assign(Object.assign({}, TypographyPDL("--zds-body-2", "paragraph3Medium")), { alignItems: "center", borderRadius: "var(--zds-radius-small, 3px)", cursor: "pointer", display: "flex", height: `var(--zds-space-32, ${MENU_ITEM_HEIGHT}px)`, padding: "0 10px", color: `var(--zds-text-default, ${Colors.neutral700})` }),
    isDisabled && withModifier("disabled", Object.assign(Object.assign({}, TypographyPDL("--zds-body-2", "paragraph3Medium")), { color: `var(--zds-text-weakest, ${Colors.neutral500})` })),
    isHighlighted && withModifier("enabled-highlighted", Object.assign(Object.assign({}, TypographyPDL("--zds-body-2", "paragraph3Medium")), { backgroundColor: `var(--zds-ui-primary-weakest, ${Colors.blue10})`, color: `var(--zds-ui-primary-strongest, ${Colors.blue})` }))
  ],
  menuItemIcon: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10
  }),
  menuItemText: css({
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  })
});
const FloatingMenu = (_props) => {
  const props = Object.assign({ align: "stretch", visibleItems: 4 }, _props);
  const { align, ariaLabel, getItemProps, getKeyForItem, getLabelForItem, getMenuProps, highlightedIndex, items, maxWidth, minWidth } = props;
  return jsx(
    FloatingBox,
    { align, maxWidth, minWidth },
    jsx("ul", Object.assign({ css: Styles.list(props) }, getMenuProps({ "aria-label": ariaLabel }), { "data-zds": true }), items.map((item, index) => jsx(
      "li",
      Object.assign({}, getItemProps({ item, disabled: item.disabled }), { css: Styles.menuItem({
        isDisabled: item.disabled,
        isHighlighted: highlightedIndex === index
      }), key: getKeyForItem ? getKeyForItem(item) : index, "data-zds": true }),
      props.renderIcon && jsx("span", { css: Styles.menuItemIcon, "data-zds": true }, props.renderIcon(item, props.getLabelForItem)),
      jsx("span", { css: Styles.menuItemText, "data-zds": true }, getLabelForItem(item))
    )))
  );
};

export { FloatingMenu };
//# sourceMappingURL=FloatingMenu.es.js.map
